require('vanilla-cookieconsent');
var cc = initCookieConsent();
cc.run({
	current_lang: 'en',
	autoclear_cookies: true,                   // default: false
	page_scripts: true,                        // default: false

	gui_options: {
		consent_modal: {
			layout: 'box',               // box/cloud/bar
			position: 'bottom right',     // bottom/middle/top + left/right/center
			transition: 'slide',           // zoom/slide
			swap_buttons: false            // enable to invert buttons
		},
		settings_modal: {
			layout: 'box',                 // box/bar
			// position: 'left',           // left/right
			transition: 'slide'            // zoom/slide
		}
	},

	onFirstAction: function(user_preferences, cookie){
		// callback triggered only once on the first accept/reject action
	},

	onAccept: function (cookie) {
		// callback triggered on the first accept/reject action, and after each page load
	},

	onChange: function (cookie, changed_categories) {
		// callback triggered when user changes preferences after consent has already been given
	},

	languages: {
		'en': {
			consent_modal: {
				title: 'We use cookies!',
				description: 'This website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
				primary_btn: {
					text: 'Accept all',
					role: 'accept_all'              // 'accept_selected' or 'accept_all'
				},
				secondary_btn: {
					text: 'Let me choose',
					role: 'settings'        // 'settings' or 'accept_necessary'
				}
			},
			settings_modal: {
				title: 'Cookie preferences',
				save_settings_btn: 'Save settings',
				accept_all_btn: 'Accept all',
				reject_all_btn: 'Reject all',
				close_btn_label: 'Close',
				cookie_table_headers: [
					{col1: 'Name'},
					{col2: 'Domain'},
					{col3: 'Expiration'},
					{col4: 'Description'}
				],
				blocks: [
					{
						title: 'Cookie usage',
						description: 'These cookies ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/privacy-policy" class="cc-link">privacy policy</a>.'
					}, {
						title: 'Strictly necessary cookies',
						description: 'These cookies are essential for the proper functioning of the website. Without these cookies, the website would not work properly',
						toggle: {
							value: 'necessary',
							enabled: true,
							readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
						},
						cookie_table: [             // list of all expected cookies
							{
								col1: 'XSRF-TOKEN',
								col2: 'www.thomaswatson.com',
								col3: 'This cookie is used for security purposes.',
								col4: '2 hours',
							},
							{
								col1: 'thomas_watson_auctioneers_session',
								col2: 'www.thomaswatson.com',
								col3: 'This cookie is used to identify your browsing session and authenticated user account',
								col4: '2 hours',
							},
							{
								col1: 'shopping_basket_id',
								col2: 'www.thomaswatson.com',
								col3: 'This cookies is used to identify your shopping basket record.',
								col4: '1 month',
							},
						]
					}, {
						title: 'Analytics cookies',
						description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
						toggle: {
							value: 'analytics',     // your cookie category
							enabled: false,
							readonly: false
						},
						cookie_table: [             // list of all expected cookies
							{
								col1: '_ga',
								col2: '.thomaswatson.com',
								col3: 'The _ga cookie, installed by Google Analytics, calculates visitor, session and campaign data and also keeps track of site usage for the site\'s analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognize unique visitors.',
								col4: '2 years',
							},
							{
								col1: '_gid',
								col2: '.thomaswatson.com',
								col3: 'Installed by Google Analytics, _gid cookie stores information on how visitors use a website, while also creating an analytics report of the website\'s performance. Some of the data that are collected include the number of visitors, their source, and the pages they visit anonymously.',
								col4: '1 day',
							}
						]
					}, {
						title: 'More information',
						description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contact-us">contact us</a>.',
					}
				]
			}
		}
	}
});